export default {
  setUser(state, item) {
    state.user = item ? item : null;
  },
  setScale(state, value) {
    state.scale = value ? value : 100;
  },
  setScreenSize(state, value) {
    state.screenSize = value;
  },
  setEducationResults(state, value) {
    state.educationResults = value;
  },

  setPendingReviews(state, value) {
    state.pendingReviews = value;
  },
};
